import { handleResponse } from '../helper/handle-response.js';
import authHeader from '../helper/auth-header.js';
import getApiKey from '../helper/getApiKey.js';

const createNewCampaign = async (id, fieldName) => {
  const body = JSON.stringify({
    default_name: fieldName,
    box_field: id
  });
  const auth = authHeader();
  const api_key = getApiKey();
  const requestOptions = {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: auth,
      api_key: api_key
    },
    body: body
  };

  return fetch(`${process.env.REACT_APP_API_URL}/orders/field/dictionary/`, requestOptions).then((r) => {
    return handleResponse(r, requestOptions).then((r) => {
      return r.json();
    });
  });
};

export default {
  createNewCampaign
};
